import React from "react";

import useTheme from "hooks/useTheme";
import ComingSoon from "views/ComingSoon";

const Security = () => {
	const { themeMode, themeColor } = useTheme();

	return (
		<div className="flex flex-col w-[50%] items-center justify-start py-5 px-5 space-y-2">
			<ComingSoon />
		</div>
	);
};

export default Security;
